import React, {Component} from 'react';
import {Dropdown} from 'semantic-ui-react';

import './dropdownField.scss';

class DropdownField extends Component {
  render() {
    const {disabled, input, options, search, multiple, fluid, loading, required, placeholder,
      'meta': {touched, error}} = this.props;
    const className = touched && error ? 'invalid' : '';

    return (
      <div className='form-dropdown-field'>
        <Dropdown
          selection
          {...input}
          search={search}
          multiple={multiple}
          value={input.value}
          options={options}
          onChange={(param, data) => input.onChange(data.value)}
          onBlur={(e, data) => input.onBlur(data.value)}
          className={className}
          disabled={disabled}
          fluid={fluid}
          loading={loading}
          placeholder={placeholder}
          style={!input.value && !disabled && required ? {'borderColor': 'red', 'backgroundColor': '#fff5f6'} : null}
        />
        {touched && (error && <span className='error-message'>{error}</span>)}
      </div>
    );
  }
}

export default DropdownField;
